import { Bookmark, PlusCircle } from "react-feather";
import { Button, Nav, NavItem } from "reactstrap";
import { Href, NewBookmark, Tags, Views } from "../../../../constants";
import { BookmarkTagList, BookmarkViewList } from "../../../../data/applications/Bookmark";
import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import { setAddModal, setTagModal, updateActiveTabs } from "../../../../reduxToolkit/reducers/bookmarkTabsSlice";
import { Link } from "react-router-dom";
import CreateBookmark from "../modal/CreateBookmark";
import Tag from "../modal/Tag";

// This component renders the sidebar navigation for the bookmark system.
const TabList = () => {
  const { activeTabs, bookMarkList } = useAppSelector((state) => state.bookmarkTab);
  const dispatch = useAppDispatch();

  // Function to update the active tab when a tab is clicked
  const onHandleClick = (id: string) => dispatch(updateActiveTabs(id));

  return (
    <Nav className="main-menu" role="tablist">
      <NavItem>
        <Button color="transparent" className="badge-light-primary btn-block w-100 btn-mail" onClick={() => dispatch(setAddModal())}>
          <Bookmark className="me-2" />{NewBookmark}<CreateBookmark />
        </Button>
      </NavItem>
      <NavItem><span className="main-title">{Views}</span></NavItem>
      {/* Mapping through bookmarkViewList to display dynamic list of available bookmark views */}
      {BookmarkViewList.map((data, index) => (
        <NavItem key={index}>
          <Link className={`${activeTabs === data.value ? "active" : ""}`} onClick={() => onHandleClick(data.value)} to={Href}>
            <span className="title">{data.title} {data.title === "Favorites" && `(${bookMarkList.length})`}</span>
          </Link>
        </NavItem>
      ))}
      <NavItem><hr /></NavItem>
      <NavItem>
        <span className="main-title">
          {Tags}
          <span className="pull-right" onClick={() => dispatch(setTagModal())}>
            <Link to={Href}><PlusCircle /></Link>
          </span>
        </span>
      </NavItem>
      <Tag />
      {/* Mapping through bookmarkTagList to display dynamic list of available bookmark tags */}
      {BookmarkTagList.map((data, index) => (
        <NavItem key={index}>
          <Link className={`${activeTabs === data.value ? "active" : ""}`} onClick={() => onHandleClick(data.value)} to={Href}>
            <span className="title"> {data.title}</span>
          </Link>
        </NavItem>
      ))}
    </Nav>
  );
};

export default TabList;